//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TextAnswersLoading'
};